/**
 * 子工程管理
 */
import { config } from 'ice';
import { store } from '@ice/stark-data';
import dayjs from 'dayjs';
import axios, { AxiosResponse } from 'axios';

store.set('config', config);

const time = dayjs().format('YYYYMMDDHHmm');

const axiosInstance = axios.create({ timeout: 10000 });

interface SubAppConfig {
  path: string;
  entry?: string;
  url?: string[];
  activePath?: string;
}

const getVersion = async (url: string) => {
  try {
    if (url) {
      const res: AxiosResponse = await axiosInstance.get(`${url}?v=${time}`);
      return `${res.data}`.replace(/\n/g, '');
    }
  } catch (e) {
    console.error(e);
  }
  return time;
};

const getApp = async (appName: string) => {
  const { entry, resources, version } = config.apps[appName];
  console.log('entry', entry);
  console.log('resources', resources);
  console.log('version', version);
  
  const cnf: SubAppConfig = {
    path: appName,
    activePath: appName,
  };
  const v = await getVersion(version);
  if (resources) {
    cnf.url = resources.map((p: string) => `${p}?v=${v}`);
  } else if (entry) {
    cnf.entry = `${entry}?v=${v}`;
  }
  return cnf;
};

export default {
  /**
   * 获取子工程相关配置
   */
  async getApps() {
    console.log('config', await Promise.all(Object.keys(config.apps ?? {}).map((appName) => getApp(appName))));
    return Promise.all(Object.keys(config.apps ?? {}).map((appName) => getApp(appName)));
  },
};
